// extracted by mini-css-extract-plugin
export default {"inputContainer":"ChatInputPane_inputContainer__2D8AW"};